import React from 'react'
import styles from './size-info.module.scss'
import image from '../../../assets/images/size-info/summer_dress.png'
import styled from 'styled-components'

function SummerDress() {
  return (
    <div className={styles.sizeInfo}>
      <div>
        <h2 className={styles.sizeInfoTitle}>
          Возьмите ваше любимое платье и проведите измерения:
        </h2>
      </div>
      <Container columns="4fr 8fr">
        <div className={styles.sizeInfoImage}>
          <img loading="lazy" src={image} />
        </div>
        <div>
          <ol>
            <li>Измерьте длину спины по центру.</li>
            <li>
              Измерьте ширину плеч от шва до шва, как указано на рисунке в
              таблице размеров (d).
            </li>
            <li>Измерьте ширину пояса вашего платья.</li>
            <li>Измерьте ширину в бёдрах в самом широком месте платья.</li>
            <li>Измерьте ширину низа вашего платья.</li>
            <li>
              В нашей таблице размеров найдите показатели, которые наиболее
              точно соответствуют получившимся цифрам.
            </li>
          </ol>
        </div>
      </Container>
    </div>
  )
}

const Container = styled.div`
  @media (min-width: 940px) {
    display: grid;
    grid-template-columns: ${(p) => p.columns};
  }
`

SummerDress.propTypes = {}

export default SummerDress
